import React, { useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Landing.css";
import WaterShopTutorials from "./WaterShopTutorials";

const commonModules = [
  ["Contabilitate & balanțe", "Note contabile, fișe de cont, registru jurnal și balanțe de verificare. Activitatea firmei și evidența contabilă, în aceeași aplicație."],
  ["Stocuri & gestiuni", "Intrări, NIR-uri, ieșiri, transferuri și bonuri de consum. Urmărești materialele și produsele în gestiunile firmei."],
  ["Facturare & parteneri", "Facturi pentru clienți, documente de la furnizori și evidența partenerilor. Documentele comerciale sunt conectate cu gestiunea."],
  ["Casă & bancă", "Încasări, plăți și urmărirea soldurilor. Legi mișcările de bani de documentele firmei."],
  ["e-Factura & raportări fiscale", "Lucrezi cu e-Factura prin SPV, jurnale TVA și raportări fiscale, inclusiv D300, D394 și SAF-T (D406)."],
  ["Mijloace fixe & obiecte de inventar", "Evidența bunurilor, amortizare și obiecte de inventar date în folosință. Urmărești transferurile și casările."],
  ["Centre de cost", "Organizezi evidența pe centre de cost asociate activităților, comenzilor și obiectivelor firmei."],
  ["Utilizatori & audit", "Drepturi de acces pe operațiuni și istoric pentru documentele urmărite. Organizezi accesul echipei la informații."],
  ["Înregistrări contabile automate", "Documentele generează note contabile care se reflectă automat în balanță. Operațiunile curente sunt conectate cu evidența contabilă a firmei."],
  ["Venituri și cheltuieli pe centre de cost", "Distribui cheltuielile și veniturile pe centre de cost pentru a urmări rezultatele pe activități, comenzi sau obiective."],
];
const applications = [
  {
    id: "productie", number: "02", name: "Producție", tone: "blue",
    title: "De la rețetă la produs finit.",
    description: "Organizezi comenzile de producție, materialele și manopera, cu evidența consumurilor legată de gestiunea firmei.",
    steps: ["Rețetă", "Comandă", "Consum & manoperă", "Produs finit"],
    modules: [
      ["Rețete de fabricație", "Definești materialele și cantitățile necesare pentru produsul finit. Rețeta activă completează necesarul comenzii."],
      ["Comenzi de producție", "Stabilești produsul, cantitatea planificată și data lansării. Urmărești comanda și materialele aferente."],
      ["Materiale & consumuri", "Înregistrezi materialele eliberate și consumurile efective. Compari consumul realizat cu cel prevăzut în rețetă."],
      ["Manoperă & angajați", "Evidențiezi manopera pe comenzile de producție și consulți rapoartele de activitate ale angajaților."],
      ["Bonuri de producție", "Înregistrezi produsele obținute prin bonuri de producție și le urmărești în gestiune."],
      ["Necesar & rapoarte", "Consulți necesarul de aprovizionare, manopera și diferențele dintre consumul efectiv și rețetă."],
    ],
  },
  {
    id: "service", number: "03", name: "Service auto", tone: "teal",
    title: "Fiecare intervenție, de la deviz la factură.",
    description: "Gestionezi devizele pentru clienți și lucrările interne, cu piese, manoperă și istoricul intervențiilor într-un singur loc.",
    steps: ["Deviz", "Piese & manoperă", "Intervenție", "Factură"],
    modules: [
      ["Devize clienți & interne", "Organizezi separat intervențiile pentru clienți și comenzile interne. Urmărești lucrările și documentele fiecărui deviz."],
      ["Piese & materiale", "Alegi produsele din gestiune și urmărești cantitățile, prețul de magazie, adaosul și prețul de vânzare."],
      ["Manoperă", "Adaugi operațiunile executate și manopera aferentă intervenției, cu evidență pe angajați."],
      ["Facturare din deviz", "Pregătești factura pornind de la devizul service, cu piesele și serviciile lucrării."],
      ["Istoric intervenții", "Consulți istoricul reparațiilor pentru un autovehicul sau un șasiu și regăsești lucrările anterioare."],
      ["Rapoarte service", "Analizezi rentabilitatea devizelor și devizele pe utilizatorul care le-a creat. Filtrezi evidența după tipul devizului."],
    ],
  },
  {
    id: "santier", number: "04", name: "Șantier", tone: "amber",
    title: "Din teren până în contabilitate.",
    description: "Pentru firmele de construcții: organizezi obiectivele și devizele, urmărești execuția zilnică și legi consumurile și facturarea de evidența firmei.",
    steps: ["Obiectiv & deviz", "Raport zilnic", "Consumuri", "Situație & factură"],
    modules: [
      ["Obiective, obiecte & devize", "Organizezi proiectul pe obiective și obiecte, cu beneficiar, termene și centru de cost. Păstrezi devizele în structura lucrării."],
      ["Import Excel / eDeviz", "Imporți lucrări și resurse din fișierele Excel acceptate, cu previzualizare înainte de salvare și verificarea dublurilor."],
      ["Raport zilnic de lucru", "Înregistrezi cantitățile executate pe lucrări și resursele utilizate: materiale, manoperă, utilaje și transport."],
      ["Gestiuni & consumuri", "Asociezi materialele cu produsele din gestiune și generezi consumurile pentru execuția confirmată, cu legătură în contabilitate."],
      ["Necesar de aprovizionare", "Urmărești materialele necesare pentru lucrările rămase, în raport cu execuția confirmată și stocul disponibil."],
      ["Situații de lucrări", "Pregătești situațiile pe baza cantităților executate, le verifici, le tipărești și le accepți pentru facturare."],
      ["Facturare integrată", "Generezi factura din situația acceptată, prin fluxul de facturare al ERP-ului, cu legătură la obiectiv și situație."],
      ["Profitabilitate pe obiectiv", "Compari veniturile facturate cu costurile identificate. Estimările și cheltuielile nealocate sunt evidențiate separat de rezultatul parțial."],
    ],
  },
  {
    id: "contor", number: "05", name: "Contor", tone: "blue",
    title: "Echipamente, citiri și contracte, până la factură.",
    description: "Pentru firmele care închiriază și întrețin echipamente: urmărești aparatele la clienți, intervențiile, citirile contoarelor și facturarea contractuală.",
    steps: ["Echipament", "Contract", "Citire & intervenție", "Factură"],
    modules: [
      ["Evidența echipamentelor", "Identifici echipamentele prin model și serie și urmărești proprietarul, utilizatorul și locația aparatului."],
      ["Contracte & alocări", "Asociezi echipamentele cu contractele clienților și urmărești perioadele de alocare și condițiile de facturare."],
      ["Citiri de contoare", "Înregistrezi citirile și urmărești consumul între două citiri, separat pentru contoarele echipamentului."],
      ["Sesizări & intervenții", "Înregistrezi sesizările și intervențiile și consulți istoricul activității pentru fiecare echipament."],
      ["Chirii & consumuri", "Pregătești facturarea chiriilor și consumurilor conform condițiilor din contract."],
      ["Facturi & anexe", "Generezi facturile și anexele cu detaliile echipamentelor și consumurilor, în legătură cu evidența ERP."],
    ],
  },
];

const contorVideos = [{"title": "Echipamente: identificare și tarife", "file": "01-echipamente", "duration": "2:07"}, {"title": "Contracte: client, perioadă și echipamente", "file": "02-contracte", "duration": "1:40"}, {"title": "Citiri: contoare noi și valori de referință", "file": "03-citiri", "duration": "1:46"}, {"title": "Sesizări și intervenții", "file": "04-interventii", "duration": "1:45"}, {"title": "Facturare: calcul, factură și anexă", "file": "05-facturare", "duration": "2:06"}, {"title": "Transferul echipamentului între clienți", "file": "06-transfer", "duration": "2:05"}];
function ContorTutorials() {
  const [selectedVideo, setSelectedVideo] = useState(0);
  const lesson = contorVideos[selectedVideo];
  const videoUrl = `${process.env.PUBLIC_URL || ""}/videos/contor/${lesson.file}`;
  return <div className="landing-tutorials" id="contor-tutoriale">
    <p className="landing-eyebrow">Învață pas cu pas</p>
    <h3>Tutoriale Contor</h3>
    <p>Șase episoade cu același echipament demonstrativ: identificare și tarife, contract, citiri, intervenții, factură și transfer între clienți.</p>
    <Row className="g-4"><Col lg={7}>
      <div id="contor-video" className="landing-video-panel">
        <h4 aria-live="polite">{selectedVideo + 1}. {lesson.title}</h4>
        <p id="contor-video-description">{lesson.duration} min · Date demonstrative · Voce în română</p>
        <video key={videoUrl} controls playsInline preload="none" poster={`${videoUrl}.png?v=contor-20261002`} aria-label={lesson.title} aria-describedby="contor-video-description">
          <source src={`${videoUrl}.mp4?v=contor-20261002`} type="video/mp4" />
          <track kind="subtitles" src={`${videoUrl}.vtt?v=contor-20261002`} srcLang="ro" label="Română" />
          Browserul nu poate reda acest video. <a href={`${videoUrl}.mp4`}>Deschide fișierul MP4</a>.
        </video>
        <a href={`${videoUrl}.mp4?v=contor-20261002`} target="_blank" rel="noopener noreferrer">Deschide video separat ↗</a>
        <a className="ms-3" data-transcript="contor" href={`${videoUrl}.txt?v=contor-20261002`} target="_blank" rel="noopener noreferrer">Citește explicațiile</a>
      </div>
    </Col><Col lg={5}><ol className="landing-lesson-list">
      {contorVideos.map((video,index) => <li key={video.file}>
        <button type="button" className="landing-lesson-button" aria-pressed={selectedVideo === index} aria-controls="contor-video" onClick={() => {
          setSelectedVideo(index);
          document.getElementById("contor-video")?.scrollIntoView({block:"start"});
        }}>{video.title}</button>
        <span className="landing-lesson-ready">{selectedVideo === index ? "Selectat" : "Video disponibil"} · {video.duration} min</span>
      </li>)}
    </ol></Col></Row>
  </div>;
}


const erpVideos = [
  { title: "Crearea unei firme noi", file: "01-crearea-firmei", duration: "1:58" },
  { title: "Intrare de la furnizor", file: "02-intrare-furnizor", duration: "2:49" },
  { title: "Intrare cu repartizare pe centre", file: "03-intrare-repartizare-centre-formular", duration: "3:40" },
  { title: "Factură către client", file: "04-factura-catre-client", duration: "3:55" },
  { title: "Plata facturii către furnizor", file: "05-plata-facturii-furnizor", duration: "2:43" },
  { title: "Încasarea facturii de la client", file: "06-incasarea-facturii-client", duration: "2:38" },
  { title: "Preluare date inițiale din Excel", file: "07-preluare-date-initiale-excel", duration: "4:56" },
  { title: "Produse, grupe și conturi contabile", file: "08-produse-grupe-conturi-clar", duration: "4:12" },
  { title: "Drepturi utilizatori", file: "09-drepturi-utilizatori-unitati", duration: "4:07" },
  { title: "Stocuri și fișa produsului", file: "10-stocuri-fisa-produsului", duration: "4:05" },
  { title: "Repartizarea cheltuielilor și veniturilor", file: "11-repartizarea-pe-centre", duration: "3:57" },
  { title: "Transfer între gestiuni", file: "12-transfer-intre-gestiuni", duration: "2:48" },
  { title: "Solduri clienți și furnizori", file: "13-solduri-clienti-furnizori", duration: "2:23" },
  { title: "Note contabile: introducere și verificare", file: "14-note-contabile", duration: "2:51" },
  { title: "Balanța de verificare", file: "15-balanta-de-verificare", duration: "2:49" },
  { title: "Verificarea și închiderea lunii", file: "16-inchiderea-lunii", duration: "2:53" },
  { title: "Ieșire cu repartizare pe centre", file: "17-iesire-repartizare-centre", duration: "3:20" },
];

function ErpTutorials() {
  const [selectedVideo, setSelectedVideo] = useState(0);
  const lesson = erpVideos[selectedVideo];
  const videoUrl = `${process.env.PUBLIC_URL || ""}/videos/erp/${lesson.file}`;
  return <div className="landing-tutorials" id="erp-tutoriale">
    <p className="landing-eyebrow">Învață pas cu pas</p>
    <h3>Tutoriale ERP</h3>
    <p>De la crearea firmei la facturi, stocuri, contabilitate și închiderea lunii. Repartizarea cheltuielilor și veniturilor pe centre este explicată într-un episod separat.</p>
    <Row className="g-4">
      <Col lg={7}>
        <div id="erp-video" className="landing-video-panel">
          <h4 aria-live="polite">{selectedVideo + 1}. {lesson.title}</h4>
          <p id="erp-video-description">{lesson.duration} min · Date demonstrative · Explicații pe ecran și voce în română</p>
          <video key={videoUrl} controls playsInline preload="none" poster={`${videoUrl}.png?v=fara-subsol-20260926`} aria-label={lesson.title} aria-describedby="erp-video-description">
            <source src={`${videoUrl}.mp4?v=fara-subsol-20260926`} type="video/mp4" />
            Browserul nu poate reda acest video. <a href={`${videoUrl}.mp4?v=fara-subsol-20260926`}>Deschide fișierul MP4</a>.
          </video>
          <a href={`${videoUrl}.mp4?v=fara-subsol-20260926`} target="_blank" rel="noopener noreferrer">Deschide video separat <span aria-hidden="true">↗</span></a>
        </div>
      </Col>
      <Col lg={5}>
        <ol className="landing-lesson-list">
          {erpVideos.map((video, index) => <li key={video.file}>
            <button type="button" className="landing-lesson-button" aria-pressed={selectedVideo === index} aria-controls="erp-video" onClick={() => {
              setSelectedVideo(index);
              document.getElementById("erp-video")?.scrollIntoView({ block: "start" });
            }}>{video.title}</button>
            <span className="landing-lesson-ready">{selectedVideo === index ? "Selectat" : "Video disponibil"} · {video.duration} min</span>
          </li>)}
        </ol>
      </Col>
    </Row>
  </div>;
}

const productieVideos = [
  { title: "Pregătirea producției", file: "01-pregatirea-productiei", duration: "3:56" },
  { title: "Crearea unei rețete", file: "02-crearea-retetei", duration: "2:44" },
  { title: "Comanda de producție", file: "03-comanda-de-productie", duration: "2:20" },
  { title: "Necesarul de materiale", file: "04-necesarul-de-materiale", duration: "2:09" },
  { title: "Materialele pentru producție", file: "05-materialele-pentru-productie", duration: "2:49" },
  { title: "Manopera pe comandă", file: "06-manopera-pe-comanda", duration: "2:23" },
  { title: "Obținerea produsului finit", file: "07-obtinerea-produsului-finit", duration: "3:13" },
  { title: "Verificarea producției și a costurilor", file: "08-verificarea-productiei-si-costurilor", duration: "3:13" },
];

function ProductieTutorials() {
  const [selectedVideo, setSelectedVideo] = useState(0);
  const lesson = productieVideos[selectedVideo];
  const videoUrl = `${process.env.PUBLIC_URL || ""}/videos/productie/${lesson.file}`;
  return <div className="landing-tutorials" id="productie-tutoriale">
    <p className="landing-eyebrow">Învață pas cu pas</p>
    <h3>Tutoriale Producție</h3>
    <p>Opt episoade cu același exemplu: de la materiale și rețetă până la produsul finit. Urmărești comanda, transferurile, consumul și manopera.</p>
    <Row className="g-4">
      <Col lg={7}>
        <div id="productie-video" className="landing-video-panel">
          <h4 aria-live="polite">{selectedVideo + 1}. {lesson.title}</h4>
          <p id="productie-video-description">{lesson.duration} min · Date demonstrative · Voce feminină în română</p>
          <video key={videoUrl} controls playsInline preload="none" poster={`${videoUrl}.png?v=fara-subsol-20260926`} aria-label={lesson.title} aria-describedby="productie-video-description">
            <source src={`${videoUrl}.mp4?v=fara-subsol-20260926`} type="video/mp4" />
            Browserul nu poate reda acest video. <a href={`${videoUrl}.mp4?v=fara-subsol-20260926`}>Deschide fișierul MP4</a>.
          </video>
          <a href={`${videoUrl}.mp4?v=fara-subsol-20260926`} target="_blank" rel="noopener noreferrer">Deschide video separat <span aria-hidden="true">↗</span></a>
        </div>
      </Col>
      <Col lg={5}>
        <ol className="landing-lesson-list">
          {productieVideos.map((video, index) => <li key={video.file}>
            <button type="button" className="landing-lesson-button" aria-pressed={selectedVideo === index} aria-controls="productie-video" onClick={() => {
              setSelectedVideo(index);
              document.getElementById("productie-video")?.scrollIntoView({ block: "start" });
            }}>{video.title}</button>
            <span className="landing-lesson-ready">{selectedVideo === index ? "Selectat" : "Video disponibil"} · {video.duration} min</span>
          </li>)}
        </ol>
      </Col>
    </Row>
  </div>;
}

const santierLessons = [
];
const santierVideos = [
  { title: "Crearea obiectivului, obiectelor și devizelor", file: "01-obiectiv-obiecte-devize" },
  { title: "Importul Excel/eDeviz și verificarea datelor", file: "02-import-excel" },
  { title: "Clasificarea resurselor și asocierea materialelor cu produsele", file: "03-clasificare-resurse" },
  { title: "Raportul zilnic: lucrări executate și resurse utilizate", file: "04-raport-zilnic" },
  { title: "Confirmarea raportului și generarea bonului de consum", file: "05-confirmare-consum" },
  { title: "Necesarul de aprovizionare", file: "06-necesar-aprovizionare" },
  { title: "Pregătirea, acceptarea și tipărirea situației de lucrări", file: "07-situatie-lucrari" },
  { title: "Generarea facturii și verificarea legăturii cu situația", file: "08-facturare-situatie" },
  { title: "Profitabilitatea obiectivului și interpretarea rezultatului", file: "09-profitabilitate" },
];

function SantierTutorials() {
  const [selectedVideo, setSelectedVideo] = useState(0);
  const lesson = santierVideos[selectedVideo];
  const videoUrl = `${process.env.PUBLIC_URL || ""}/videos/santier/${lesson.file}`;
  return <div className="landing-tutorials" id="santier-tutoriale">
    <p className="landing-eyebrow">Învață pas cu pas</p>
    <h3>Tutoriale Șantier</h3>
    <p>De la primul obiectiv la analiza rezultatului, fiecare etapă este prezentată prin exemple în aplicație.</p>
    <Row className="g-4">
      <Col lg={7}>
        <div id="santier-video-obiectiv" className="landing-video-panel">
          <h4 aria-live="polite">{selectedVideo + 1}. {lesson.title}</h4>
          <p id="santier-video-description">2 minute · Date demonstrative · Explicații pe ecran și voce în română</p>
          <video key={videoUrl} controls playsInline preload="none" poster={`${videoUrl}.png?v=fara-subsol-20260926`} aria-label={lesson.title} aria-describedby="santier-video-description">
            <source src={`${videoUrl}.mp4?v=fara-subsol-20260926`} type="video/mp4" />
            Browserul nu poate reda acest video. <a href={`${videoUrl}.mp4?v=fara-subsol-20260926`}>Deschide fișierul MP4</a>.
          </video>
          <a href={`${videoUrl}.mp4?v=fara-subsol-20260926`} target="_blank" rel="noopener noreferrer">Deschide video separat <span aria-hidden="true">↗</span></a>
        </div>
      </Col>
      <Col lg={5}>
        <ol className="landing-lesson-list">
          {santierVideos.map((video, index) => <li key={video.file}>
            <button type="button" className="landing-lesson-button" aria-pressed={selectedVideo === index} aria-controls="santier-video-obiectiv" onClick={() => {
              setSelectedVideo(index);
              document.getElementById("santier-video-obiectiv")?.scrollIntoView({ block: "start" });
            }}>{video.title}</button>
            <span className="landing-lesson-ready">{selectedVideo === index ? "Selectat" : "Video disponibil"} · 2 min</span>
          </li>)}
          {santierLessons.map((lesson) => <li key={lesson}><span>{lesson}</span><span className="landing-lesson-status">În pregătire</span></li>)}
        </ol>
      </Col>
    </Row>
  </div>;
}

const serviceLessons = [];
const serviceVideos = [{"title": "Comanda client — recepție și deviz", "file": "01-deviz-client", "duration": "4 min 37 s"}, {"title": "Piese și materiale", "file": "02-piese-materiale"}, {"title": "Manoperă și mecanici", "file": "03-manopera"}, {"title": "Închidere și facturare", "file": "04-facturare"}, {"title": "Lucrări pentru parcul propriu", "file": "05-lucrari-interne"}, {"title": "Istoric și rapoarte", "file": "06-istoric-rapoarte"}];
function ServiceTutorials() {
  const [selectedVideo, setSelectedVideo] = useState(0);
  const lesson = serviceVideos[selectedVideo];
  const videoUrl = `${process.env.PUBLIC_URL || ""}/videos/service/${lesson.file}`;
  return <div className="landing-tutorials" id="service-tutoriale">
    <p className="landing-eyebrow">Învață pas cu pas</p>
    <h3>Tutoriale Service auto</h3>
    <p>De la comanda client și recepție la deviz și factură, cu piese, manoperă și istoricul intervențiilor.</p>
    <Row className="g-4">
      <Col lg={7}>
        <div id="service-video-obiectiv" className="landing-video-panel">
          <h4 aria-live="polite">{selectedVideo + 1}. {lesson.title}</h4>
          <p id="service-video-description">{lesson.duration || "2 min"} · Date demonstrative · Explicații pe ecran și voce în română</p>
          <video key={videoUrl} controls playsInline preload="none" poster={`${videoUrl}.png?v=comanda-client-20261001`} aria-label={lesson.title} aria-describedby="service-video-description">
            <source src={`${videoUrl}.mp4?v=comanda-client-20261001`} type="video/mp4" />
            Browserul nu poate reda acest video. <a href={`${videoUrl}.mp4?v=comanda-client-20261001`}>Deschide fișierul MP4</a>.
          </video>
          <a href={`${videoUrl}.mp4?v=comanda-client-20261001`} target="_blank" rel="noopener noreferrer">Deschide video separat <span aria-hidden="true">↗</span></a>
        </div>
      </Col>
      <Col lg={5}>
        <ol className="landing-lesson-list">
          {serviceVideos.map((video, index) => <li key={video.file}>
            <button type="button" className="landing-lesson-button" aria-pressed={selectedVideo === index} aria-controls="service-video-obiectiv" onClick={() => {
              setSelectedVideo(index);
              document.getElementById("service-video-obiectiv")?.scrollIntoView({ block: "start" });
            }}>{video.title}</button>
            <span className="landing-lesson-ready">{selectedVideo === index ? "Selectat" : "Video disponibil"} · {video.duration || "2 min"}</span>
          </li>)}
          {serviceLessons.map((lesson) => <li key={lesson}><span>{lesson}</span><span className="landing-lesson-status">În pregătire</span></li>)}
        </ol>
      </Col>
    </Row>
  </div>;
}

function ModuleCards({ items, common = false }) {
  return <Row className="g-3 g-xl-4">
    {items.map(([title, description], index) => <Col key={title} md={6} xl={common ? 3 : 6}>
      <Card className="landing-module-card h-100"><Card.Body>
        {common && <span className="landing-card-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>}
        <h3>{title}</h3><p className="mb-0">{description}</p>
      </Card.Body></Card>
    </Col>)}
  </Row>;
}

export default function Landing() {
  return <div className="erp-landing">
    <nav className="landing-topbar" aria-label="Navigație principală">
      <Container className="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <Link className="landing-brand" to="/landing">EDA ERP <span>Cloud</span></Link>
        <div className="d-flex flex-wrap gap-2">
          <Button as={Link} to="/login" variant="outline-primary">Autentificare</Button>
          <Button as={Link} to="/register">Încearcă gratuit 30 zile</Button>
        </div>
      </Container>
    </nav>
    <main>
      <Container className="landing-hero"><Row className="align-items-center g-4 gx-lg-5">
        <Col lg={7}>
          <p className="landing-eyebrow">O singură platformă pentru firma ta</p>
          <h1>Aplicația potrivită activității tale.<br /><span>Cu contabilitatea inclusă.</span></h1>
          <p className="landing-lead">Contabilitate, stocuri și facturare într-o bază comună. Alegi modulul opțional potrivit firmei: Producție, Service auto, Șantier, Contor sau Distribuție apă. Poți adăuga și Magazin online.</p>
          <div className="d-flex flex-wrap gap-3">
            <Button as="a" href="#module" size="lg">Descoperă aplicațiile <span aria-hidden="true">↓</span></Button>
            <Button as={Link} to="/register" variant="outline-primary" size="lg">Începe gratuit</Button>
          </div>
        </Col>
        <Col lg={5}><div className="landing-platform">
          <a className="landing-erp-overview landing-erp" href="#module">
            <span className="landing-erp-overview-title">ERP <span aria-hidden="true">↗</span></span>
            <ul>{commonModules.map(([title]) => <li key={title}>{title}</li>)}</ul>
          </a>
          <p className="landing-eyebrow">Module opționale</p>
          {applications.map((app) => <a key={app.id} className={`landing-app-link landing-${app.tone}`} href={`#${app.id}`}><span>{app.name}</span><span aria-hidden="true">↗</span></a>)}
          <a className="landing-app-link landing-teal" href="#distributie-apa"><span>Distribuție apă</span><span aria-hidden="true">↗</span></a>
          <a className="landing-app-link landing-blue" href="#magazin-online"><span>Magazin online</span><span aria-hidden="true">↗</span></a>
        </div></Col>
      </Row></Container>
      <div className="landing-module-nav"><Container><nav aria-label="Grupe de module" className="d-flex flex-wrap gap-2">
        <a href="#module">01 · ERP</a>
        <a href="#distributie-apa">Distribuție apă</a>
        <a href="#magazin-online">Magazin online</a>
        {applications.map((app) => <a key={app.id} href={`#${app.id}`}>{app.number} · {app.name}</a>)}
      </nav></Container></div>
      <section id="module" className="landing-section landing-application landing-erp" aria-labelledby="common-title"><Container><Row className="g-4 g-xl-5">
        <Col lg={4}>
          <p className="landing-eyebrow">01 / Aplicație ERP</p>
          <h2 id="common-title">ERP</h2>
          <p className="landing-app-tagline">Evidența firmei, într-un singur loc.</p>
          <p className="landing-description">Organizezi activitatea firmei într-o singură aplicație: parteneri, produse, facturi de cumpărare și vânzare, gestiuni, încasări și plăți. Urmărești documentele de la intrarea mărfii și întocmirea NIR-ului până la livrare, facturare și decontare.</p>
          <ol className="landing-flow" aria-label="Flux ERP">{["Documente & parteneri", "Stocuri & facturare", "Încasări & plăți", "Contabilitate & rapoarte"].map((step, index) => <li key={step}><span aria-hidden="true">{index + 1}</span>{step}</li>)}</ol>
          <p className="landing-integration">Baza comună pentru Producție, Service auto, Șantier, Contor, Distribuție apă și Magazin online.</p>
          <a className="btn btn-outline-dark" href="#erp-tutoriale">Vezi tutorialele ERP ↓</a>
        </Col>
        <Col lg={8}><ModuleCards items={commonModules} /></Col>
      </Row><ErpTutorials /></Container></section>
      {applications.map((app) => <section key={app.id} id={app.id} className={`landing-section landing-application landing-${app.tone}`} aria-labelledby={`${app.id}-title`}><Container><Row className="g-4 g-xl-5">
        <Col lg={4}>
          <p className="landing-eyebrow">{app.number} / Aplicație {app.name}</p>
          <h2 id={`${app.id}-title`}>{app.name}</h2>
          <p className="landing-app-tagline">{app.title}</p>
          <p className="landing-description">{app.description}</p>
          <ol className="landing-flow" aria-label={`Flux ${app.name}`}>{app.steps.map((step, index) => <li key={step}><span aria-hidden="true">{index + 1}</span>{step}</li>)}</ol>
          <p className="landing-integration">Conectată cu modulele comune de contabilitate, gestiune și facturare.</p>
          {app.id === "contor" && <a className="btn btn-outline-dark" href="#contor-tutoriale">Vezi tutorialele Contor ↓</a>}
          {app.id === "service" && <a className="btn btn-outline-dark" href="#service-tutoriale">Vezi tutorialele Service ↓</a>}
          {app.id === "santier" && <a className="btn btn-outline-dark" href="#santier-tutoriale">Vezi tutorialele Șantier ↓</a>}
          {app.id === "productie" && <a className="btn btn-outline-dark" href="#productie-tutoriale">Vezi tutorialele Producție ↓</a>}
        </Col>
        <Col lg={8}><ModuleCards items={app.modules} /></Col>
      </Row>{app.id === "contor" && <ContorTutorials />}{app.id === "santier" && <SantierTutorials />}{app.id === "service" && <ServiceTutorials />}{app.id === "productie" && <ProductieTutorials />}</Container></section>)}
      <section className="landing-section landing-application landing-teal" id="distributie-apa"><Container>
        <p className="landing-eyebrow">Modul opțional</p>
        <h2>Distribuție apă</h2>
        <p>Gestionezi contractele clienților și apometrele, organizezi citirile pe străzi și generezi facturile din consumurile înregistrate. Facturile generate în lot rămân neconfirmate pentru verificare.</p>
        <ModuleCards items={[
          ["Contracte și tarife", "Stabilești produsele și tarifele pentru apă și canalizare în contractul clientului."],
          ["Apometre și citiri", "Înregistrezi apometrele și indicii, cu foi de citire organizate pe străzi."],
          ["Facturare în lot", "Generezi facturi din citiri și verifici consumurile și valorile înainte de confirmare."],
          ["Evidență în ERP", "Facturile se regăsesc în evidența clienților și în contabilitatea firmei."]
        ]} />
        <WaterShopTutorials kind="apa" />
      </Container></section>
      <section className="landing-section landing-application landing-blue" id="magazin-online"><Container>
        <p className="landing-eyebrow">Opțiune suplimentară pentru firma ta</p>
        <h2>WooCommerce conectat cu ERP-ul</h2>
        <p>Publici articolele și stabilești prețurile în ERP. Adaugi fotografiile și descrierile în WooCommerce. Clienții comandă în magazin, iar comenzile se preiau automat în ERP, unde verifici disponibilitatea și pregătești facturarea.</p>
        <p>Fiecare firmă are propriul magazin WordPress + WooCommerce, cu baza de date și fișiere separate. Activarea se face de administratorul platformei din Panou Superadmin.</p>
        <div className="d-flex flex-wrap gap-3 mb-4">
          <Button as="a" href="#magazin-tutoriale">Vezi tutorialele ERP + WooCommerce</Button>
          <Button as={Link} to="/register" variant="outline-primary">Creează firma în ERP</Button>
        </div>
        <WaterShopTutorials kind="magazin" />
      </Container></section>
      <section className="landing-cta"><Container className="text-center">
        <p className="landing-eyebrow">EDA ERP Cloud</p>
        <h2>O evidență comună. Funcții pentru activitatea ta.</h2>
        <p>Descoperă cum lucrează împreună aplicațiile și contabilitatea firmei tale.</p>
        <Button as={Link} to="/register" size="lg" variant="light" className="fw-semibold">Creează cont · 30 zile gratuit</Button>
      </Container></section>
    </main>
    <footer className="landing-footer"><Container>&copy; {new Date().getFullYear()} EDA ERP Cloud. Toate drepturile rezervate.</Container></footer>
  </div>;
}


